import { render } from "./SupportComp.vue?vue&type=template&id=f048aafc&scoped=true"
import script from "./SupportComp.vue?vue&type=script&lang=js"
export * from "./SupportComp.vue?vue&type=script&lang=js"

import "./SupportComp.vue?vue&type=style&index=0&id=f048aafc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f048aafc"]])

export default __exports__